import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { IdentifiersControl } from '@/module/Author/Publication/IdentifiersControl';
import { BdiMultiSelectControl } from '@/module/Nomen/Bdi/BdiMultiSelectControl';
import { LanguageSelectControl } from '@/module/Nomen/Language/LanguageSelectControl';
import { WosCategoryMultiSelectControl } from '@/module/Nomen/WosCategory/WosCategoryMultiSelectControl';
import { WosIndexMultiSelectControl } from '@/module/Nomen/WosIndex/WosIndexMultiSelectControl';

import { NumberInputControl, PublishedAtControl, TextInputControl } from '@/core/components';

export interface PublicationControlProps {
  isSubmitting: boolean;

  showWosFields: boolean;
  showScopusFields: boolean;
}

export function PublicationControl(props: PublicationControlProps) {
  const { isSubmitting, showScopusFields, showWosFields } = props;
  const { t } = useTranslation();

  return (
    <>
      <TextInputControl
        name="title"
        label={t('publications.form.fields.title')}
        isSubmitting={isSubmitting}
      />
      <Group align="flex-end">
        <PublishedAtControl
          name="publishedAt"
          label={t('publications.form.fields.publishedAt')}
          isSubmitting={isSubmitting}
          withAsterisk
        />
        <LanguageSelectControl
          name="language"
          label={t('publications.form.fields.language')}
          isSubmitting={isSubmitting}
          withAsterisk
        />
      </Group>
      <IdentifiersControl
        isSubmitting={isSubmitting}
        showScopusFields={showScopusFields}
        showWosFields={showWosFields}
      />
      <Group>
        <NumberInputControl
          withAsterisk
          name="noOfPages"
          label={t('publications.form.fields.noOfPages')}
          isSubmitting={isSubmitting}
          allowDecimal={false}
        />
        <NumberInputControl
          withAsterisk
          name="startPage"
          label={t('publications.form.fields.startPage')}
          isSubmitting={isSubmitting}
          allowDecimal={false}
        />
        <NumberInputControl
          withAsterisk
          name="endPage"
          label={t('publications.form.fields.endPage')}
          isSubmitting={isSubmitting}
          allowDecimal={false}
        />
      </Group>
      {showWosFields && (
        <>
          <WosCategoryMultiSelectControl
            name="wosCategories"
            label={t('publications.form.fields.wosCategories')}
            isSubmitting={isSubmitting}
          />
          <WosIndexMultiSelectControl
            name="wosIndexes"
            label={t('publications.form.fields.wosIndexes')}
            isSubmitting={isSubmitting}
          />
        </>
      )}
      <BdiMultiSelectControl
        label={t('publications.form.fields.bdiList')}
        name="bdis"
        isSubmitting={isSubmitting}
      />
      <TextInputControl
        name="link"
        label={t('publications.form.fields.link')}
        isSubmitting={isSubmitting}
      />
      <NumberInputControl
        name="universityAffiliatedNoOfAuthors"
        label={t('publications.form.fields.universityAffiliatedNoOfAuthors')}
        description={t('publications.form.fields.universityAffiliatedNoOfAuthorsDescription')}
        isSubmitting={isSubmitting}
        allowDecimal={false}
      />
      <NumberInputControl
        name="noOfRoAuthors"
        label={t('publications.form.fields.noOfRoAuthors')}
        isSubmitting={isSubmitting}
        allowDecimal={false}
      />
    </>
  );
}
